export default __webpack_public_path__ + "static/media/no-updates.03106607.png";